import { io } from 'socket.io-client';
import config from '../config';

/** Desactivado: evita intentos wss/socket.io y errores en consola hasta que nginx/proxy esté estable. */
const WEBSOCKET_ENABLED = false;

class SocketService {
  constructor() {
    this.socket = null;
    this.isConnected = false;
    this.listeners = new Map();
  }

  connect(token) {
    if (!WEBSOCKET_ENABLED) {
      this.isConnected = false;
      return;
    }

    if (this.socket && this.isConnected) {
      return;
    }

    const serverUrl = config.backendUrl;
    console.log('🔌 WebSocket conectando a:', serverUrl);
    
    this.socket = io(serverUrl, {
      auth: {
        token: token
      },
      transports: ['websocket', 'polling'],
      timeout: 5000,
      forceNew: true
    });

    this.socket.on('connect', () => {
      console.log('🔌 ✅ Conectado al servidor WebSocket correctamente');
      this.isConnected = true;
    });

    this.socket.on('disconnect', () => {
      console.log('🔌 ❌ Desconectado del servidor WebSocket');
      this.isConnected = false;
    });

    this.socket.on('connect_error', (error) => {
      console.error('❌ Error de conexión WebSocket:', error);
      this.isConnected = false;
    });

    // Escuchar notificaciones
    this.socket.on('notification', (notification) => {
      console.log('📨 Notificación recibida:', notification);
      this.emit('notification', notification);
    });

    // Escuchar actualizaciones de expediente
    this.socket.on('expediente_update', (update) => {
      console.log('📁 Actualización de expediente:', update);
      this.emit('expediente_update', update);
    });
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
      this.isConnected = false;
    }
  }

  // Unirse a un expediente específico
  joinExpediente(expedienteId) {
    if (this.socket && this.isConnected) {
      this.socket.emit('join_expediente', expedienteId);
    }
  }

  // Salir de un expediente específico
  leaveExpediente(expedienteId) {
    if (this.socket && this.isConnected) {
      this.socket.emit('leave_expediente', expedienteId);
    }
  }

  // Suscribirse a eventos
  on(event, callback) {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, []);
    }
    this.listeners.get(event).push(callback);
  }

  // Desuscribirse de eventos
  off(event, callback) {
    if (this.listeners.has(event)) {
      const callbacks = this.listeners.get(event);
      const index = callbacks.indexOf(callback);
      if (index > -1) {
        callbacks.splice(index, 1);
      }
    }
  }

  // Emitir eventos internos
  emit(event, data) {
    if (this.listeners.has(event)) {
      this.listeners.get(event).forEach(callback => {
        try {
          callback(data);
        } catch (error) {
          console.error(`Error en callback para evento ${event}:`, error);
        }
      });
    }
  }

  // Verificar si está conectado
  getConnectionStatus() {
    return this.isConnected;
  }
}

// Instancia singleton
const socketService = new SocketService();

export default socketService;
